import RaikoMoneyInputOutlined from "./RaikoMoneyInputOutlined";
import PropTypes from "prop-types";
import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";
import {css} from "@emotion/css";
import {convertCurrencyFormatPositiveNegative} from "../../util/numberConvertor";
import React from "react";


const RaikoSimpleInputOutlined = (
    {
        labelText = "",
        placeHolder = "",
        value,
        setValue,
        className,
        disabled
    }) => {
    return (
        <RaikoMaterialOutlinedInput
            placeHolder={placeHolder}
            labelText={labelText}
            className={className}
            disabled={disabled}
            value={value}
            onChange={({target}) => {
                setValue(target.value)
            }}/>
    )
}

RaikoSimpleInputOutlined.propTypes = {
    placeHolder: PropTypes.string,
    disabled: PropTypes.bool,
    labelText: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired
}

export default RaikoSimpleInputOutlined